import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HelpCircleIcon, ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Necesito experiencia previa?',
  a: <>
        No. Está escrito para quien nunca tocó la resina. Cada paso explicado{' '}
        <strong className="text-[#2563EB]" data-id="element-65">desde cero</strong> con el por qué
        detrás de cada acción.
      </>
}, {
  q: '¿Funciona si estoy en el interior de Uruguay?',
  a: <>
        Sí. La guía incluye{' '}
        <strong className="text-[#2563EB]" data-id="element-66">proveedores verificados</strong> en
        todo el país. Todo se consigue localmente.
      </>
}, {
  q: '¿Cuánto dinero necesito para empezar?',
  a: <>
        Para tu primer proyecto podés arrancar con entre $UY 8.000 y $UY 18.000
        en materiales dependiendo del tamaño de la mesa y la madera que elijas.
        El ebook te dice exactamente qué comprar primero para no gastar de más.
      </>
}, {
  q: '¿Cuánto tiempo lleva hacer una mesa?',
  a: <>
        Entre 5 y 7 días incluyendo los tiempos de curado. El trabajo activo son
        entre 6 y 10 horas distribuidas en esos días.
      </>
}, {
  q: '¿Qué pasa si cometo un error?',
  a: <>
        El capítulo 14 tiene los{' '}
        <strong className="text-[#2563EB]" data-id="element-67">8 errores más comunes</strong> con
        solución completa. La mayoría tienen reparación sin perder la mesa ni
        los materiales.
      </>
}, {
  q: '¿Cómo recibo el libro?',
  a: <>
        PDF descargable. Recibís el link en tu email inmediatamente después del
        pago. <strong className="text-[#2563EB]" data-id="element-68">Acceso de por vida</strong> en
        celular, tablet o computadora.
      </>
}, {
  q: '¿Hay garantía?',
  a: <>
        Sí. 7 días de devolución total sin preguntas. Si no cumplió lo que
        prometió te devolvemos el 100% del dinero.
      </>
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-[56px] md:py-[80px] px-5 bg-[#F9FAFB] relative" data-id="element-69">
      <div className="max-w-3xl mx-auto" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-12" data-id="element-71">
          <h2 className="text-title-section font-bold text-[#1A3A5C] mb-6 flex items-center justify-center gap-4" data-id="element-72">
            <HelpCircleIcon className="w-8 h-8 text-[#C9A84C]" data-id="element-73" />
            PREGUNTAS FRECUENTES
          </h2>
          <div className="w-24 h-1 bg-[#C9A84C]/30 mx-auto mt-6" data-id="element-74"></div>
        </motion.div>

        <div className="space-y-0" data-id="element-75">
          {faqs.map((faq, index) => <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.1
        }} key={index} className="border-b border-gray-200 last:border-0" data-id="element-76">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full py-[20px] flex items-center justify-between text-left hover:bg-gray-50/50 transition-colors" aria-expanded={openIndex === index} data-id="element-77">
                <span className="text-subtitle font-bold text-[#1A3A5C] pr-8" data-id="element-78">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-[20px] h-[20px] text-[#C9A84C] shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-79" />
              </button>
              <AnimatePresence initial={false} data-id="element-80">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-81">
                    <div className="pb-[20px] text-body-main text-gray-600 leading-relaxed" data-id="element-82">
                      <p className="max-w-3xl" data-id="element-83">{faq.a}</p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}